import { __ } from '@wordpress/i18n';

export const STORE_NAME = 'mwsb/filters';

export const DEFAULT_FILTERS = {
	search: '',
	categories: [],
	tags: [],
	minPrice: '',
	maxPrice: '',
	orderby: 'menu_order',
	includeChildren: true,
	page: 1,
};

export const ORDER_OPTIONS = [
	{ value: 'menu_order', label: __( 'Default',            'mwsb' ) },
	{ value: 'date',       label: __( 'Newest',             'mwsb' ) },
	{ value: 'date_asc',   label: __( 'Oldest',             'mwsb' ) },
	{ value: 'price_asc',  label: __( 'Price: Low to High', 'mwsb' ) },
	{ value: 'price_desc', label: __( 'Price: High to Low', 'mwsb' ) },
	{ value: 'name_asc',   label: __( 'A - Z',              'mwsb' ) },
	{ value: 'name_desc',  label: __( 'Z - A',              'mwsb' ) },
];
